import {
  PackageFullness,
  AnalyticDataEntity,
  AnalyticLoginEntity,
  AnalyticEvent,
  DataLayer,
  EcommerceItem
} from 'src/api/analytic.types';
import { DrugItem } from 'src/api/types';
import logger from 'src/utils/logger';
import { BLISTER_STRING, IS_TRACKING_DISABLED } from './useAnalytics.contants';
import {
  DrugEcommerceItem,
  AnalyticPreparedDrugListProps,
  PackageQuantityDetails
} from './useAnalytics.types';

declare const dataLayer: DataLayer;

const ecommerceAnalyticEvents = new Set([
  AnalyticEvent.Purchase,
  AnalyticEvent.BeginCheckout,
  AnalyticEvent.ViewCart,
  AnalyticEvent.ViewItem,
  AnalyticEvent.SelectItem
]);

export const getPackageFullness = ({
  packQuantity,
  unitQuantity = 0
}: PackageQuantityDetails): PackageFullness => {
  if (packQuantity > 0 && unitQuantity > 0) {
    return PackageFullness.FullPortion;
  }
  if (packQuantity > 0 || (packQuantity === 0 && unitQuantity === 0)) {
    return PackageFullness.Full;
  }

  return PackageFullness.Portion;
};

export const getEcommerceItems = (
  drug: DrugEcommerceItem,
  packageQuantityDetails: PackageQuantityDetails
): EcommerceItem[] => {
  try {
    const {
      packQuantity,
      unitQuantity = 0,
      quantityUnitInPack = 0
    } = packageQuantityDetails;

    const { price } = drug;

    const items = [];

    if (packQuantity > 0) {
      items.push({
        item_name: drug.name,
        item_id: drug.id,
        price,
        item_brand: drug.maker,
        item_category: drug.category,
        item_list_name: drug.analytics?.itemListName,
        index: drug.analytics?.index,
        quantity: packQuantity
      });
    }

    if (unitQuantity > 0) {
      const unitPrice = Number((price / quantityUnitInPack).toFixed(2));

      items.push({
        item_name: `${drug.name} (${BLISTER_STRING})`,
        item_id: `${drug.id}_${BLISTER_STRING}`,
        price: unitPrice,
        item_brand: drug.maker,
        item_category: drug.category,
        item_list_name: drug.analytics?.itemListName,
        index: drug.analytics?.index,
        quantity: unitQuantity
      });
    }

    return items;
  } catch (error) {
    logger.error(error);
  }
};

export const getAnalyticPreparedDrugList = ({
  drugs,
  itemListName
}: AnalyticPreparedDrugListProps): DrugItem[] =>
  (drugs ?? []).map((value, index) => ({
    ...value,
    analytics: {
      itemListName,
      index: String(index + 1)
    }
  }));

export const sendAnalytics = (
  analyticsData: AnalyticDataEntity | AnalyticLoginEntity
): void => {
  try {
    if (IS_TRACKING_DISABLED) {
      logger.log('sendAnalytics', analyticsData);
      return;
    }

    if (ecommerceAnalyticEvents.has(analyticsData.event)) {
      dataLayer.push({ ecommerce: null });
    }

    dataLayer.push(analyticsData);
  } catch (error) {
    logger.error(error);
  }
};
